// import { ReactComponent as EditIcon } from '@common/icons/Edit.svg';
// import { ReactComponent as ReplyIcon } from '@common/icons/Reply.svg';
// import { ReactComponent as ThumbsUpIcon } from '@common/icons/ThumbsUp.svg';
import React from 'react';

import StarRating from './StarRating';

export interface ReviewProps {
  className?: string;
  rating?: number;
  total?: number;
  name: string;
  date: string;
  review: string;
}

function spliter(dateStr: string) {
  const arr = dateStr.split(' ');
  return arr[2] + ' ' + arr[1] + ' ' + arr[3];
}

const ReviewComponent: React.FunctionComponent<ReviewProps> = ({ name, review, className = '', rating, date }) => {
  return (
    <>
      <div className={`flex w-full mb-40 ${className}`} font-customisation="para-text">
        {/* <div className="w-150 md:w-3/4 mr-20"> */}
        <div className="w-full">
          <div className="flex mb-12 text-16 md:text-20 text-title font-medium items-center">
            <div
              className="text-khamaj-black text-16 leading-20 md:text-20 md:leading-24 fonr-semibold md:font-bold"
              color-customisation="page-body-text"
            >
              {name}
            </div>
            <div className="flex ml-4">
              {rating != null ? (
                <StarRating rating={rating} total={5} isInteractive={false} className="ml-10 transform scale-40" />
              ) : null}
            </div>
            <div className="flex-1 text-right">
              <div className="text-16 font-normal text-khamaj-black" color-customisation="page-body-text">
                {spliter(date)}
              </div>
            </div>
          </div>
          <div
            className="leading-21 text-16 md:leading-24 font-normal text-khamaj-black"
            color-customisation="page-body-text"
          >
            {review}
          </div>
        </div>
      </div>
    </>
  );
};

export default ReviewComponent;
